import React from 'react';
import GridContainer from '../../../@jumbo/components/GridContainer';
import Backdrop from '@material-ui/core/Backdrop';
import CmtCard from '../../../@coremat/CmtCard';
import CmtCardContent from '../../../@coremat/CmtCard/CmtCardContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import Grid from '@material-ui/core/Grid';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import SidebarButtons from '../../../@jumbo/components/AppLayout/partials/SideBar/SIdebarButtons';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import Input from '@material-ui/core/Input';
import { DatePicker, KeyboardTimePicker, KeyboardDatePicker } from '@material-ui/pickers';
import Button from '@material-ui/core/Button';
import { Box } from '@material-ui/core/';
import axios from 'axios';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { useSelector } from 'react-redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import AppContext from '../../../@jumbo/components/contextProvider/AppContextProvider/AppContext';
import { Alert, AlertTitle } from '@material-ui/lab';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import LanguageSwitcher from '../../Booking/LanguageSwitcher';

const breadcrumbs = [
  { label: <IntlMessages id={'sidebar.main'} />, link: '/' },
  { label: <IntlMessages id={'pages.quickReservation'} />, isActive: true },
];

function MyAlert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function getMyDate(prop) {
  var md = new Date(prop);
  var dd = String(md.getDate()).padStart(2, '0');
  var mm = String(md.getMonth() + 1).padStart(2, '0');
  var yyyy = md.getFullYear();
  return yyyy + '-' + mm + '-' + dd;
}

const useStyles = theme => ({
  card: {
    overflow: 'unset',
    marginBottom: theme.typography.pxToRem(32),
  },
  cardContent: {
    position: 'relative',
    paddingBottom: 0,
  },
  cardContentInner: {
    position: 'relative',
    paddingBottom: 0,
  },
  formControl: {
    margin: theme.spacing(2),
    minWidth: 200,
  },
  guestPrice: {
    minWidth: 200,
  },
  currency: {
    minWidth: 200,
    marginLeft: 10,
  },
});

class PriceList extends React.Component {
  useStyles = makeStyles(theme => ({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  }));
  constructor(props) {
    super(props);
    //    const classes = this.useStyles();
    /*const { authUser } = useSelector(({ auth }) => auth);*/
    var languageData = [];
    var languageItem = {};
    languageItem = {
      languageId: 'croatian',
      locale: 'hr',
      name: 'Hrvatski',
      icon: 'hr',
    };
    languageData.push(languageItem);
    var languageItem = {};
    languageItem = {
      languageId: 'english',
      locale: 'en',
      name: 'English',
      icon: 'us',
    };
    languageData.push(languageItem);
    this.state = {
      languageData: languageData,
      posId: this.props.match.params.posId,
      hotelId: this.props.match.params.hotelId,
      securityCode: this.props.match.params.securityCode,
      groups: [{ id: 1, name: { hr: 'testgrupa', en: 'testengrupa' } }],
      items: [{ id: 1, groupId: 1, name: { hr: 'kava', en: 'coffie' } }],
      cart: [],
      step: 0,
    };
    this.addItem = this.addItem.bind(this);
    this.order = this.order.bind(this);
  }

  handleChange(name, value) {
    if (value == null) return;
    this.setState({ [name]: value }, () => {
      //   this.updateRooms();
    });
  }

  doAction(name, value) {
    if (name == null) return;
    if (name == 'Reset') {
      this.setState({ idPOS: 0 });
    } else {
      this.setState({ [name]: value }, () => {
        //   this.updateRooms();
      });
    }
  }

  loadPriceList() {
    if (this.state.hotelId == null || this.state.posId == null) return;
  }

  componentDidMount() {
    const { currentPage, setCurrentPage } = this.context;
    const { intl } = this.props;
    //  laodPriceList();
    setCurrentPage(intl.formatMessage({ id: 'pages.gastroHomePage' }));
  }

  addItem(item, quantity) {
    this.setState(prevState => {
      const oitems = [...prevState.cart];
      var index = oitems.findIndex(itemx => itemx.id == item.id);
      if (index == -1) {
        if (quantity > 0) oitems.push({ id: item.id, quantity: quantity });
      } else {
        oitems[index].quantity += quantity;
        if (oitems[index].quantity <= 0) oitems.splice(index, 1);
      }
      return { cart: oitems };
    });
  }

  order() {
    var request = {
      Action: 'sendPosOrder',
      hotelId: this.state.hotelId,
      SecurityCode: this.state.securityCode2,
      posId: this.state.posId,
      cart: this.state.cart,
      comment: this.state.comment,
      email: this.state.email,
      telephone: this.state.telephone,
      roomNumber: this.state.roomNumber,
    };
  }

  render() {
    console.log('x1');
    //var language = 'hr';
    const language = this.context.locale.locale;

    return (
      <>
        <LanguageSwitcher languageData={this.state.languageData} />

        {this.state.groups.map(group => (
          <>
            {this.state.step == 0 && (
              <>
                <b>{group.name[language]}</b>
                {this.state.items
                  .filter(item => item.groupId == group.id)
                  .map(item => (
                    <>
                      <b>
                        {this.state.cart.filter(itemx => itemx.id == item.id).length == 1 && (
                          <>
                            {this.state.cart.filter(itemx => itemx.id == item.id)[0].quantity}
                            {' x '}
                          </>
                        )}
                        {item.name[language]}
                      </b>
                      <br />
                      <Button onClick={() => this.addItem(item, 1)}>Add</Button>
                      <Button onClick={() => this.addItem(item, -1)}>Remove</Button>
                    </>
                  ))}
              </>
            )}
            {this.state.step == 1 && (
              <>
                {this.state.cart.map(item => (
                  <>
                    {item.id}
                    {item.quantity}
                  </>
                ))}
              </>
            )}
          </>
        ))}
        {this.state.step == 0 && this.state.cart.length > 0 && (
          <Button onClick={() => this.setState({ step: 1 })}>Review</Button>
        )}
        {this.state.step == 1 && this.state.cart.length > 0 && (
          <Button onClick={() => this.setState({ step: 0 })}>Back</Button>
        )}
        {this.state.step == 1 && this.state.cart.length > 0 && <Button onClick={() => this.order()}>Order</Button>}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

PriceList.contextType = AppContext;
export default withStyles(useStyles)(connect(mapStateToProps)(injectIntl(PriceList)));
/*

 */
